/**
 * Converts a value to a specific precision.
 * @param value - the value to convert
 * @param precision - the precision or decimal points
 * @returns {number}
 */
export const toPrecision = (value: number, precision: number): number => {
  const scaleFactor = 10 ** (precision ?? 10);
  const nextValue = Math.round(value * scaleFactor) / scaleFactor;
  return nextValue;
};
